export default __webpack_public_path__ + "static/card-img05-dec2a1d60ab5e73bb443133b33619161.jpg";